const mapper_options = {
  endpoint: 'ad_run_tasks',
  recordClass: require('./record')
}

module.exports = (store) => {
  store.defineMapper('campaign_reporting_ad_run_tasks', mapper_options)
}
